/**
 * KTTablist - Custom Element para manejo de pestañas de género
 */
if (!customElements.get('kt-tablist')) {
    class KTTablist extends HTMLElement {
        constructor() {
            super();
            this.handleClick = this.handleClick.bind(this);
            console.log(' KTTablist');
        }

        connectedCallback() {
            this.addEventListener('click', this.handleClick);
        }

        disconnectedCallback() {
            this.removeEventListener('click', this.handleClick);
        }

        handleClick(e) {

            const button = e.target.closest('span[role=tab]');
            console.log('Click en:', button)
            if (!button || !this.contains(button)) return;

            const gender = button.dataset.gender;

            this.querySelectorAll('span[role=tab]').forEach((btn) => {
                btn.setAttribute('aria-selected', 'false');
            });
            button.setAttribute('aria-selected', 'true');

            this.dispatchEvent(
                new CustomEvent('gender-change', {
                    detail: { gender },
                    bubbles: true,
                })
            );
        }
    }

    customElements.define('kt-tablist', KTTablist);
}

/**
 * Lógica de filtrado y visualización de tallas (PDP + PLP)
 */
(function () {

    // Busca los elementos que comiencen con las letras K, J, H o M
    const SIZE_LETTER_RE = /[KJHM]\d+/;

    // Estado de género activo para PLP (persiste entre re-renders AJAX)
    let plpActiveGender = null;

    // ──────────────────────────────────────────────
    // PDP helpers
    // ──────────────────────────────────────────────

    function findSizeFieldset() {
        const fieldsets = document.querySelectorAll('.product-form__input');
        for (const fs of fieldsets) {
            const radios = fs.querySelectorAll('input[type=radio]');
            for (const r of radios) {
                if (SIZE_LETTER_RE.test(r.value)) return fs;
            }
        }
        return null;
    }

    function detectProductMode(fieldset) {
        if (!fieldset) return 'unknown';
        const values = Array.from(
            fieldset.querySelectorAll('input[type=radio]')
        ).map((r) => r.value);

        if (values.length === 0) return 'unknown';

        const hasK = values.some((v) => /K\d+/.test(v));
        const hasJ = values.some((v) => /J\d+/.test(v));
        const hasH = values.some((v) => /H\d+/.test(v));
        const hasM = values.some((v) => /M\d+/.test(v));

        if (hasH || hasM) return 'adult';
        if (hasK && !hasJ) return 'kids-small';
        if (hasK || hasJ) return 'kids-big';
        return 'adult';
    }

    function renderAgeLabel(mode, fieldset) {
        const existing = document.querySelector('.kt-size-age-label');
        if (existing) existing.remove();

        if (mode !== 'kids-small' && mode !== 'kids-big') return;

        const label = document.createElement('p');
        label.className = 'kt-size-age-label';
        label.textContent =
            mode === 'kids-small'
                ? 'Niños Pequeños (Edades 1 - 5)'
                : 'Niños Grandes (Edades 5+)';

        fieldset.insertAdjacentElement('beforebegin', label);
    }

    function toggleTablist(mode) {
        const tablist = document.querySelector('kt-tablist');
        if (!tablist) return;
        if (mode === 'kids-small' || mode === 'kids-big') {
            tablist.classList.add('kt-tablist--hidden');
        } else {
            tablist.classList.remove('kt-tablist--hidden');
        }
    }

    function updateSizesByGender(gender) {
        const fieldset = findSizeFieldset();
        if (!fieldset) return;

        const items = [];

        fieldset.querySelectorAll('input[type=radio]').forEach((radio) => {
            const label = fieldset.querySelector('label[for=' + radio.id + ']');
            const value = radio.value;

            const h = value.match(/H(\d+)/)?.[1];
            const m = value.match(/M(\d+)/)?.[1];

            let size = null;
            let show = true;

            if (gender === 'W') {
                size = m;
                show = !!m;
            } else if (gender === 'M') {
                size = h;
                show = !!h;
            } else {
                size = value.replace(/[HM]/g, '');
            }

            if (show && size) {
                items.push({
                    radio,
                    label,
                    size: Number(size),
                    text: size,
                });
            } else {
                radio.style.display = 'none';
                if (label) label.style.display = 'none';
            }
        });

        items.sort((a, b) => a.size - b.size);

        items.forEach((item) => {
            const { radio, label, text } = item;
            radio.style.display = '';
            if (label) {
                label.style.display = '';
                label.childNodes[0].nodeValue = text;
            }
            fieldset.appendChild(radio);
            if (label) fieldset.appendChild(label);
        });
    }

    function setupPDP() {
        if (isPLP()) return;

        const fieldset = findSizeFieldset();
        const mode = detectProductMode(fieldset);

        toggleTablist(mode);

        if (mode === 'kids-small' || mode === 'kids-big') {
            if (fieldset) renderAgeLabel(mode, fieldset);
            return;
        }

        const activeTab = document.querySelector(
            'kt-tablist span[aria-selected=true]'
        );
        const gender = activeTab?.dataset.gender || 'W';
        updateSizesByGender(gender);
    }

    // ──────────────────────────────────────────────
    // PLP helpers
    // ──────────────────────────────────────────────

    function isPLP() {
        return !!document.querySelector('facet-filters-form');
    }

    function getActivePLPGender() {
        if (plpActiveGender) return plpActiveGender;
        const activeTab = document.querySelector(
            'fieldset.facets-wrap kt-tablist span[aria-selected=true],'
            + ' .mobile-facets__details kt-tablist span[aria-selected=true]'
        );
        return activeTab?.dataset.gender || 'W';
    }

    function restorePLPTabState(gender) {
        document.querySelectorAll('kt-tablist').forEach(function (tablist) {
            if (!tablist.closest('.facets-wrap') && !tablist.closest('.mobile-facets__details')) return;
            tablist.querySelectorAll('span[role=tab]').forEach(function (tab) {
                tab.setAttribute('aria-selected', tab.dataset.gender === gender ? 'true' : 'false');
            });
        });
    }

    function updatePLPFacetSizes(gender) {

        const fieldsets = document.querySelectorAll('fieldset.facets-wrap[data-filter-label], .mobile-facets__submenu[data-filter-label]');

        fieldsets.forEach(function (fieldset) {
            const filterLabel = (fieldset.dataset.filterLabel || '').toLowerCase();
            if (filterLabel.indexOf('size') === -1 && filterLabel.indexOf('talla') === -1) return;

            const listItems = fieldset.querySelectorAll('li.list-menu__item, li.mobile-facets__item');

            // Limpia etiquetas previas
            fieldset.querySelectorAll('.kt-size-label-group').forEach(el => el.remove());

            listItems.forEach(function (li) {


                const input = li.querySelector('input[type=checkbox]');
                if (!input) return;

                const rawValue = input.value;

                if (!SIZE_LETTER_RE.test(rawValue)) return;

                const textLabel = li.querySelector('.facet-checkbox__text-label');
                if (!textLabel) return;

                if (!textLabel.dataset.originalLabel) {
                    textLabel.dataset.originalLabel = textLabel.textContent;
                }

                const h = (rawValue.match(/H(\d+)/) || [])[1] || null;
                const m = (rawValue.match(/M(\d+)/) || [])[1] || null;
                const k = (rawValue.match(/K(\d+)/) || [])[1] || null;
                const j = (rawValue.match(/J(\d+)/) || [])[1] || null;

                let friendlySize = null;
                let show = true;

                if (gender === 'W') {
                    friendlySize = m;
                    show = !!m;
                } else if (gender === 'M') {
                    friendlySize = h;
                    show = !!h;
                } else if (gender === 'C') {
                    friendlySize = k || j;
                    show = !!(k || j);
                    if (friendlySize) friendlySize = rawValue;
                } else {
                    friendlySize = textLabel.dataset.originalLabel;
                    show = true;
                }

                if (show && friendlySize) {
                    li.style.display = '';
                    textLabel.textContent = friendlySize;
                } else {
                    li.style.display = 'none';
                }
            });

            // Inyección de etiquetas en Niños para el filtro.
            if ( gender === 'C') {
                // Obtener los ítems visibles y sus tallas
                let visibles = Array.from(listItems).filter(li => li.style.display !== 'none');

                if(visibles?.length === 0) return;

                // Ordenar por talla: primero K (menores), luego J (mayores)
                visibles.sort((a, b) => {
                    const getSize = (li) => {
                        const label = li.querySelector('.facet-checkbox__text-label');
                        if (!label) return 999;
                        // K primero, luego J
                        let matchK = label.textContent.match(/^K(\d+)$/);
                        let matchJ = label.textContent.match(/^J(\d+)$/);
                        if (matchK) return parseInt(matchK[1], 10); // K1, K2, ...
                        if (matchJ) return 100 + parseInt(matchJ[1], 10); // J29, J30... (100+ para ir después de K)
                        return 999;
                    };
                    return getSize(a) - getSize(b);
                });

                // Limpiar el contenedor antes de reinsertar
                const ul = visibles[0]?.parentNode;
                if (ul) {
                    visibles.forEach(li => ul.removeChild(li));
                }

                // Insertar spans y volver a agregar los items ordenados
                let insertedSmall = false;
                let insertedBig = false;

                // Niños pequeños antes de la primera K
                if (!insertedSmall) {
                    const span = document.createElement('span');
                    span.className = 'kt-size-label-group';
                    span.textContent = 'Niños pequeños (Edades 1-5 años)';
                    ul?.appendChild(span);
                    insertedSmall = true;
                }

                visibles.forEach((li) => {
                    const label = li.querySelector('.facet-checkbox__text-label');
                    if (!label) return;
                    let matchK = label.textContent.match(/^K(\d+)$/);
                    let matchJ = label.textContent.match(/^J(\d+)$/);

                    // Niños grandes después de K28 (es decir, antes de K29 o cualquier J)
                    if (
                        !insertedBig &&
                        (
                            (matchK && parseInt(matchK[1], 10) === 29) ||
                            (matchJ) // por si hay J directamente después de K28
                        )
                    ) {
                        const span = document.createElement('span');
                        span.className = 'kt-size-label-group kt-size-label-group--padding-top';
                        span.textContent = 'Niños grandes (Edades 5+)';
                        ul?.appendChild(span);
                        insertedBig = true;
                    }
                    ul.appendChild(li);
                });

                
            }
       
        });
    }

    function setupPLP() {
        if (!isPLP()) return;
        const gender = getActivePLPGender();
        plpActiveGender = gender;
        updatePLPFacetSizes(gender);

    }

    // ──────────────────────────────────────────────
    // Event listeners
    // ──────────────────────────────────────────────

    document.addEventListener('gender-change', (e) => {
        const gender = e.detail.gender;

        // PDP
        updateSizesByGender(gender);

        // PLP
        if (isPLP()) {
            plpActiveGender = gender;
            updatePLPFacetSizes(gender);
        }
    });

    document.addEventListener('facets-rendered', function () {
        if (!isPLP() || !plpActiveGender) return;
        restorePLPTabState(plpActiveGender);
        updatePLPFacetSizes(plpActiveGender);
    });

    // Soporte para cambios de variante en temas modernos de Shopify
    if (typeof subscribe === 'function') {
        subscribe('variant-change', () => setupPDP());
    }

    function boot() {
        setupPDP();
        setupPLP();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', boot);
    } else {
        boot();
    }
})();